module.exports = __webpack_public_path__ + "img/logo_other-costs.f065cbc7.svg";